import React from 'react';
import ListPagination from '@/components/list-pagination';

function getBasePageLink({
  type,
  category,
  query,
}: {
  type: string;
  category?: string;
  query?: string;
}) {
  switch (type) {
    case 'category':
      return `/faq/${category}/`;
    case 'search':
      return `/faq/search?q=${query}&page=`;
    default:
      return `/faq/${category}/`;
  }
}

/** FAQ 목록·검색 공용 — UI 는 공용 `ListPagination`, 여기는 링크 생성만 담당한다 */
export default function FaqPagination({
  category,
  page,
  pages,
  type,
  query,
}: {
  category: string;
  pages: string[];
  page: string;
  type: string;
  query?: string;
}) {
  return (
    <ListPagination
      pages={pages}
      current={page}
      hrefBase={getBasePageLink({ type, category, query })}
    />
  );
}
